// NOTE: We no longer have these many labels.
// We only have two labels: `Client Feedback` and `Client Visible`
// `Client Visible`: Show this issue in the fg dashboard.
// `Client Feedback`: This issue is a an client feedback item requested by the client.
//
// To determine action items for a project,
// 1. take all the issues with the label `Client Visible`
// 2. filter out the issues with the label `Client Feedback`
//
// To determine support requests for a client, take all the issues with the label `Client Visible`
// We don't have to do anything special here cause all support requests belong to one project. So we can just take all the issues with the label `Client Visible`

export const ActionItemIssueLabels = [
  // old ones
  "Client task",
  "Client Task",
  // new ones
  "Client Action",
]

export const FeedbackItemIssueLabels = ["Client Feedback"]

export const SupportRequestIssueLabels = ["Client Request"]

export const VisibleIssueLabels = ["Client Visible"]

export const ActionItemStatuses = [
  "Triage",
  "Backlog",
  "Todo",
  "In Progress",
  "In Review",
  "Done",
  "Completed",
  "Canceled",
] as const

export const ActionItemPriorities = [
  /** The priority of the issue. 0 = No priority, 1 = Urgent, 2 = High, 3 = Normal, 4 = Low. */
  "No priority",
  "Urgent",
  "High",
  "Normal",
  "Medium",
  "Low",
] as const

export const SupportRequestActiveStatuses = [
  "Triage",
  "Backlog",
  "Todo",
  "In Progress",
  "In Review",
  "Client Input Required",
  "Client Review",
  "Blocked",
] as const

export const SupportRequestResolvedStatuses = [
  "Done",
  "Completed",
  "Duplicate",
  "Canceled",
  "Declined",
] as const

export const SupportRequestStatuses = [
  ...SupportRequestActiveStatuses,
  ...SupportRequestResolvedStatuses,
] as const
export type SupportRequestStatus = (typeof SupportRequestStatuses)[number]

export const SupportRequestPriorities = [
  "Urgent",
  "High",
  "Medium",
  "Low",
  "No priority",
  "Normal",
] as const
export type SupportRequestPriority = (typeof SupportRequestPriorities)[number]

export const FeedbackItemStatuses = SupportRequestStatuses
export type FeedbackItemStatus = (typeof FeedbackItemStatuses)[number]

export const FeedbackItemPriorities = SupportRequestPriorities
export type FeedbackItemPriority = (typeof FeedbackItemPriorities)[number]
